import type { NativeRouteMeta } from '@retailer-platform/dashboard/routing-native'
import type { routes } from './routes'

export const nativeRouteMeta = {
  name: 'orders-operational-dashboard-tracking-page',
  autoEnable: false,
} as const satisfies NativeRouteMeta<keyof typeof routes>
